var exports = {
  "kL": "ChannelPermissionsTab.module__container___RFVjbm",
  "Ut": "ChannelPermissionsTab.module__syncBanner___RFVjbm",
  "iH": "ChannelPermissionsTab.module__syncBannerSynced___RFVjbm",
  "bT": "ChannelPermissionsTab.module__syncBannerUnsynced___RFVjbm",
  "Vg": "ChannelPermissionsTab.module__grid___RFVjbm",
  "s4": "ChannelPermissionsTab.module__leftTitle___RFVjbm",
  "pG": "ChannelPermissionsTab.module__right___RFVjbm",
  "ze": "ChannelPermissionsTab.module__rightScroller___RFVjbm",
  "CI": "ChannelPermissionsTab.module__sectionRow___RFVjbm",
  "bV": "ChannelPermissionsTab.module__sectionHeader___RFVjbm",
  "Gf": "ChannelPermissionsTab.module__sectionTitle___RFVjbm",
  "bQ": "ChannelPermissionsTab.module__subtleText___RFVjbm",
  "cy": "ChannelPermissionsTab.module__permHeaderRow___RFVjbm",
  "mA": "ChannelPermissionsTab.module__permHelp___RFVjbm",
  "p$": "ChannelPermissionsTab.module__emptyState___RFVjbm",
  "rV": "ChannelPermissionsTab.module__overwriteItem___RFVjbm",
  "w7": "ChannelPermissionsTab.module__overwriteItemSelected___RFVjbm",
  "Vd": "ChannelPermissionsTab.module__overwriteItemContextMenuOpen___RFVjbm",
  "FD": "ChannelPermissionsTab.module__overwriteIcon___RFVjbm",
  "m4": "ChannelPermissionsTab.module__roleDot___RFVjbm",
  "l": "ChannelPermissionsTab.module__overwriteName___RFVjbm",
  "Fs": "ChannelPermissionsTab.module__permSearchRow___RFVjbm",
  "XZ": "ChannelPermissionsTab.module__permSearchInput___RFVjbm",
  "sN": "ChannelPermissionsTab.module__layoutButtons___RFVjbm",
  "Zh": "ChannelPermissionsTab.module__layoutButton___RFVjbm",
  "HU": "ChannelPermissionsTab.module__permCategories___RFVjbm",
  "Fv": "ChannelPermissionsTab.module__mobileOverrideList___RFVjbm",
  "E_": "ChannelPermissionsTab.module__mobileListHeader___RFVjbm",
  "JJ": "ChannelPermissionsTab.module__mobileListTitle___RFVjbm",
  "_4": "ChannelPermissionsTab.module__mobileOverrides___RFVjbm",
  "Ud": "ChannelPermissionsTab.module__mobileOverrideItem___RFVjbm",
  "wP": "ChannelPermissionsTab.module__mobileOverrideName___RFVjbm",
  "wu": "ChannelPermissionsTab.module__mobileOverrideChevron___RFVjbm",
  "yg": "ChannelPermissionsTab.module__mobileBackRow___RFVjbm",
};

module.exports = exports;
